// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The canvas's right-hand panel (CanvasSidePanels.tsx): the collaboration
   panel, under the top bar, scrolling within the window. */

._XnsnR3dzHnz0aMXt7Yt {
  position: absolute;
  top: var(--curio-top-bar-height);
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-height: calc(100vh - var(--curio-top-bar-height) - 16px);
  pointer-events: none;
}

._XnsnR3dzHnz0aMXt7Yt > * {
  pointer-events: auto;
  min-height: 0;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/CanvasSidePanels.module.css"],"names":[],"mappings":"AAAA;2DAC2D;;AAE3D;EACE,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* The canvas's right-hand panel (CanvasSidePanels.tsx): the collaboration\n   panel, under the top bar, scrolling within the window. */\n\n.dock {\n  position: absolute;\n  top: var(--curio-top-bar-height);\n  right: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  max-height: calc(100vh - var(--curio-top-bar-height) - 16px);\n  pointer-events: none;\n}\n\n.dock > * {\n  pointer-events: auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dock": `_XnsnR3dzHnz0aMXt7Yt`
};
export default ___CSS_LOADER_EXPORT___;
